export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6717.8b676869.jpg";